import React, { useEffect, useState, useRef } from 'react';
import {createRoot} from 'react-dom/client';
import {Col, Button, Modal} from 'react-bootstrap';
import GoogleMapReact from 'google-map-react';
import { useSelector } from "react-redux";
import APICom from "../../utils/helpers/APICom.js";
import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';
import CabOffline from "../../assets/Images/MapImages/Cab_Offline.png";
import CabDisconnected from "../../assets/Images/MapImages/Cab_Disconnected.png";
import LiftOccupied from "../../assets/Images/MapImages/Lift_OCCUPIED.png";
import LiftOnline from "../../assets/Images/MapImages/Lift_ONLINE.png";
import SedanOccupied from "../../assets/Images/MapImages/Sedan_OCCUPIED.png";
import SedanOnline from "../../assets/Images/MapImages/Sedan_Online.png";
import VanOccupied from "../../assets/Images/MapImages/VAN_OCCUPIED.png";
import VanOnline from "../../assets/Images/MapImages/VAN_ONLINE.png";
import PUIcon from "../../assets/Images/MapImages/PUMarker.png";
import NewTripPUIcon from "../../assets/Images/MapImages/NewTripPUIcon.png";
import NewTripDOIcon from "../../assets/Images/MapImages/NewTripDOIcon.png";
import AlertLocationMarkerIcon from "../../assets/Images/MapImages/AlertLocationMarkerIcon.png";
import DOIcon from "../../assets/Images/MapImages/DropoffIcon.png";
import SDepot from "../../assets/Images/MapImages/StartDepotIcon.png";
import EDepot from "../../assets/Images/MapImages/EndDepotIcon.png";
import WalkIcon from "../../assets/Images/MapImages/walkMarkerIcon.png";
import DropMicrotransitIcon from "../../assets/Images/MapImages/dropMicrotransitMarkerIcon.png";
import {Icon} from '@iconify/react';
import MultiSelectDropdown from './multiselectdropdown';

const MapControlSkeleton = (props = {}) => {
    const [selectedZone, setSelectedZone] = useState('');
    const { ASCSSettingData, VirtualStopsData, AffiliateData } = useSelector((store) => store.combinedata); 
    const [zoomOpt, setZoomOpt] = useState(props.options.mapZoomOpts);
    const ITCMapURL = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ? 
    (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"geocode?latlng=":"http://itcmap.itcurves.us/api/Map/geocode?latlng=";
    const ITCMapDirections = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ? 
    (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"directions":"http://itcmap.itcurves.us/api/Map/directions";
    const OSRM_Username = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ? 
    (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value:"annapolis";
    const OSRM_Password = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ? 
    (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value:"barwoodpass";
    const [GlobalMapsObjects, setGlobalMapsObjects] = useState({});
    let [markers, setMarkers] = useState([]);
    let [zoneVSMarkers, setZoneVSMarkers] = useState([]);
    let [PolyPaths, setPolyPaths] = useState([]);
    let [polygons, setPolygons] = useState([]);
    let [infowindows, setinfowindows] = useState([]);
    let [vsInfowindows, setVsInfowindows] = useState([]);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalFooterHTML, setModalFooterHTML] = useState(null);
    let [recenterBtnCreatedFlag, setRecenterBtnCreatedFlag] = useState(false);
    let [searchPOICreatedFlag, setSearchPOICreatedFlag] = useState(false);
    const [inputPOI, setInputPOI] = useState("");
    const [ZonesFilterMultiSelect, SetZonesFilterMultiSelect] = useState({options: [], selectedValues:[],
        placeholder:"Zone Selection", displayValue:"name", emptyRecordMsg:"N/A", singleSelect:false, showCheckbox:true,
        className:"DispatchGridAttributesSelect text-nowrap m-1 shadow-sm",SelectAllPlaceHolder:"All Zones", AllItemsSelectedPlaceHolder:"All Zones",
        styles:{width:"auto", maxWidth:"200px", display:"block"}}
    );

    // const zoneSelection = useRef("All Zones");
    const mapZoneCreated = useRef(false);
    const resetMapFromCallTaker = useRef(false);
    const IsCallInProgressForHandleApiLoaded = useRef("false");
    const rightClickListenerRef = useRef(false);
    const zoneList = useRef([]);
    const affChangedRef = useRef("");
    const polylinePointsMicro = useRef({pick: 0, drop: 0});
    let startCenterLat = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ? 
        (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value: 39.16552683625823;
    let startCenterLng = props.options.mapOptions.aff && ASCSSettingData[props.options.mapOptions.aff] ?  
        (JSON.parse(ASCSSettingData[props.options.mapOptions.aff]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value: -77.16834351718929;
    let vehImageArr = [];
    let state = {
        center: {lat:39.16552683625823, lng:-77.16834351718929},//{lat:39.16552683625823, lng:-77.16834351718929}, // IT Curves coordinates
        zoom: props.options.mapOptions.zoom,
        tilt: props.options.mapOptions.tilt,
        mapHeight: props.options.mapHeight,
        heightoffset: 183,
        mapId: "90f87356969d889c",
        options: {
            gestureHandling: 'greedy',
            zoomControl: zoomOpt.zoomControl,
            draggable: zoomOpt.draggable,
            scrollWheel: zoomOpt.scrollWheel,
            disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom,
        },
        places: props.MapDetailData,
    };
    state = {...state, ...props.options};
    // let polygons = [];

    useEffect(()=>{
        if(props.CurrentAff)
        {
            affChangedRef.current = props.CurrentAff;
            startCenterLat = ASCSSettingData[props.CurrentAff] ? 
                (JSON.parse(ASCSSettingData[props.CurrentAff]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value: 39.16552683625823;
            startCenterLng = ASCSSettingData[props.CurrentAff] ? 
                (JSON.parse(ASCSSettingData[props.CurrentAff]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value: -77.16834351718929;
        }
    }, [props.CurrentAff]);

    useEffect(()=>{
        try{
            if(props.microPolylinePoints && props.microPolylinePoints.pick !== 0 && props.microPolylinePoints.drop !== 0)
                polylinePointsMicro.current = props.microPolylinePoints;
        }
        catch(err){console.log(err);}
    }, [props.microPolylinePoints]);

    useEffect( () => {
        try{
            if(typeof GlobalMapsObjects.map !== 'undefined'){
                ResetMapFromCallTaker();
                resetMapFromCallTaker.current = false;
                if(state.places.length === 0)
                {
                    if(!props.options.mapOptions.aff)
                    {
                        GlobalMapsObjects.map.setCenter(state.center);
                    }
                    else
                    {
                        if(affChangedRef.current !== "")
                        {
                            startCenterLat = ASCSSettingData[props.CurrentAff] ? 
                                (JSON.parse(ASCSSettingData[props.CurrentAff]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value
                                : 39.16552683625823;
                            startCenterLng = ASCSSettingData[props.CurrentAff] ? 
                                (JSON.parse(ASCSSettingData[props.CurrentAff]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value
                                : -77.16834351718929;
                        }
                        GlobalMapsObjects.map.setCenter({lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)});
                        mapZoneCreated.current = false;
                    }
                }
                else
                {
                    mapZoneCreated.current = false;
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP].length > 0)
                    {
                        // GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP].removeAt(0);
                    }
                    // GlobalMapsObjects.map.setZoom(state.zoom);
                    if(selectedZone != undefined)
                    {
                        mapZoneCreated.current = true;
                    }
                    // handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                    if(IsCallInProgressForHandleApiLoaded.current == false){
                        wrapperCallHandleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                        //handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                    }
                }
                
            }
        }
        catch(err){console.log(err);}
        
    }, [props.MapDetailData]);

    useEffect(() => {
        if (props.onConditionMet) {
            ResetMapFromCallTaker(); // Trigger the method if condition is met
        }
    }, [props.onConditionMet]);

    useEffect( () => {
        try{
            
            if(props.options.mapOptions.aff && typeof GlobalMapsObjects.map !== 'undefined' && !mapZoneCreated.current)
            {
                GlobalMapsObjects.map.setCenter({lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)});
                for(let i = 0; i < polygons.length; i++) {
                    polygons[i].setMap(null);
                }
                polygons = [];
                // setMapZoneCreated(false);
                // handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                getMapZones(GlobalMapsObjects.map, GlobalMapsObjects.maps);
            }
            
        }
        catch(err){console.log(err);}
        
    }, [props.options.mapOptions.aff]);

    useEffect(()=>{
        try{
            if(typeof GlobalMapsObjects.map !== 'undefined')
            {
                if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP].length > 0)
                {
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP].removeAt(0);
                }
                const controlDiv = document.createElement('div'); 
                const root = createRoot(controlDiv);
                root.render(
                    <MultiSelectDropdown options={ZonesFilterMultiSelect} SelectionChangeCallback={ZoneSelectionCallback} FireSelectEventOnEveryItemChange={true}/>    
                );
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP].push(controlDiv);
            }
        }
        catch(err){console.log(err);}
        

    },[ZonesFilterMultiSelect.options]);
    
    useEffect( ()=>{
        try{
            if(typeof GlobalMapsObjects.map !== 'undefined' && props.reArrangedRows && props.reArrangedRows.length > 0){
                let rowReArrangePolyLineDataArr = [];
                for(var k = 0; k < props.reArrangedRows.length; k++)
                {
                    let mapInfo = null;
                    let eta = null;
                    if(props.reArrangedRows[k].Type === "PU")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.reArrangedRows[k].Latitude), 
                            parseFloat(props.reArrangedRows[k].Longitude));
                        eta = (props.reArrangedRows[k].SchTime);
                        rowReArrangePolyLineDataArr.push({trip:"P", latLng: mapInfo, time: eta});
                    }
                    else if(props.reArrangedRows[k].Type === "DO")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.reArrangedRows[k].Latitude), 
                            parseFloat(props.reArrangedRows[k].Longitude));
                        eta = (props.reArrangedRows[k].SchTime);
                        rowReArrangePolyLineDataArr.push({trip:"D", latLng: mapInfo, time: eta});  
                    }
                    
                }
                if(PolyPaths.length > 0)
                {
                    for(let i = 0; i < PolyPaths.length; i++) {
                        PolyPaths[i].setMap(null);
                    }
                    
                    getStraightPolylines(rowReArrangePolyLineDataArr, GlobalMapsObjects.map, GlobalMapsObjects.maps);
                }
                // console.log(props.reArrangedRows);
            }
        }
        catch(err){console.log(err);}
        
    },[props.reArrangedRows]);

    const wrapperCallHandleApiLoaded = async(map, maps, state) => {
        try {
            const hasValidCoordinates = Array.isArray(state) && state.length > 0 && state.every(loc => {
            const { lat, lng } = loc || {};
                return (
                    typeof lat === "number" &&
                    typeof lng === "number" &&
                    !isNaN(lat) &&
                    !isNaN(lng)
                );
            });

            if (hasValidCoordinates) {
                await handleApiLoaded(map, maps, state);
            } else {
                console.warn("Skipping API call — one or more coordinates are invalid:", state);
            }
        } catch (error) {console.log(error);}
    };

    

    function stopAnimation(marker)
    {
        setTimeout(() => {
            marker.setAnimation(null);
        }, 3000);
    }

       // Parsing data
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const ParseGeoCodedData = (data, Identifier, Index = 0) => {
    
    var IndexLocal = 0;
    if (typeof Index == 'undefined') IndexLocal = Index;


    var StreatNum = ""; var route = ""; var Locality = ""; var Admin3 = ""; var Admin2 = ""; var Admin1 = ""; var Country = ""; var PostalCode = "";
    var establishment = ""; var neighborhood = ""; var park = ""; var premise = ""; var subpremise = ""; var sublocality = ""; var intersection = "";

    var StreatNum_short = ""; var route_short = ""; var neighborhood_short = ""; var park_short = ""; var premise_short = ""; var subpremise_short = ""; var intersection_short = "";
    var FormatedAddress = "";
      data.address_components.forEach((component) => {
        const componentType = component.types[0];
        const longName = component.long_name;
        const shortName = component.short_name;

        switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
                break;
            case 'route': route = longName; route_short = shortName;
                break;
            case 'locality': Locality = longName;
                break;
            case 'administrative_area_level_3': Admin3 = longName;
                break;
            case 'administrative_area_level_2': Admin2 = longName;
                break;
            case 'administrative_area_level_1': Admin1 = shortName;
                break;
            case 'country': Country = longName;
                break;
            case 'postal_code': PostalCode = longName;
                break;
            case 'establishment': establishment = longName;
                break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
                break;
            case 'park': park = longName; park_short = shortName;
                break;
            case 'premise': premise = longName; premise_short = shortName;
                break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
                break;
            case 'sublocality': sublocality = longName;
                break;
            case 'intersection': intersection = longName; intersection_short = shortName;
                break;
            default: break;
        }

    });
    FormatedAddress = data.formatted_address;
    if (!PostalCode) {
    }
    if (Admin1.trim() == Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
    }
    var AggregatedStreetAdddr = "";
    AggregatedStreetAdddr = (premise.trim() == "" ? "" : premise + ", ") + (subpremise.trim() == "" ? "" : subpremise + ", ") + (park.trim() == "" ? "" : park + ", ") + ((neighborhood.trim() == "" || route != "" || StreatNum != "") ? "" : neighborhood + ", ") + (intersection.trim() == "" ? "" : intersection + ", ") + StreatNum + " " + route;
    

    try {
        if (FormatedAddress.split(',').length > 0) {

            var StreetAdd = data.formatted_address.split(',')[0];
            if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1 || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1 || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
                || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1 || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1 || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) {
                AggregatedStreetAdddr = StreetAdd;
            }
        }
    } catch (CrashFailSafe) { }
    var isPoiLatLong = false;
    try {
        if (typeof data.placessearchedresult != 'undefined') {
            if (data.placessearchedresult == true) {
                isPoiLatLong = true;
            }
        }
    }
    catch (twa) { }
    var _mapSource = "unkwnSource";
    try {
        if (typeof data.mapSource != 'undefined') {
            _mapSource = data.mapSource;
        }
    } catch (setMapSrcExp) { }
    var ParsedData = {
        "Street": AggregatedStreetAdddr.trim() == "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality == "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() == "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": data.geometry.location.lat,
        "Long": data.geometry.location.lng,
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber == undefined || data.sUnitNumber == null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource

    }
    return ParsedData;
};
// ___________________

    const enableDisableMap = (isEnable = true) => {
        try {
            if(GlobalMapsObjects && typeof GlobalMapsObjects.map !== 'undefined')
            {
                GlobalMapsObjects.map.setOptions({
                    clickableIcons: isEnable,
                    draggable: isEnable,
                    zoomControl: isEnable,
                    scrollwheel: isEnable,
                    disableDoubleClickZoom: isEnable,
                });
            }
        } catch (error) {console.log(error);}
    };

    const handleMapPointSelection = async(type, info)=>{
        try{
            props.setIsSchTimeFieldDisabled(true);
            props.setIsVSSelectionDisabled(true);
            setShowDynamicModal(false);
            let myHeaders = new Headers();
            myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
            myHeaders.append('Content-Type', 'application/json');
            let addressAPI = ITCMapURL + info;
            let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
            enableDisableMap(false);
            if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
            {
                let Addr = OSRMResponse.data.results[0].formatted_address;
                let ParsedData = ParseGeoCodedData(OSRMResponse.data.results[0], "", 0);
                props.mapPointSelection([{latlng:info, address:Addr, type:type, addressParsedObject:ParsedData}]);
            }
            else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
            {
                setModalHeaderText("No Address Found");
                setModalBodyHTML("No address was found for the selected point");
                setModalFooterHTML(
                    <Button variant='secondary' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} onClick={()=>{setShowDynamicModal(false);}}>
                        OK
                    </Button>
                );
                setShowDynamicModal(true);
            }    
            enableDisableMap();
            // if(type === "PU")
            // {
            //     if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
            //     {
            //         let PUAddr = OSRMResponse.data.results[0].formatted_address;
            //         let PUParsedData = ParseGeoCodedData(OSRMResponse.data.results[0], "", 0);
            //         props.mapPointSelection([{latlng:info, address:PUAddr, type:"PU", addressParsedObject:PUParsedData}]);
            //     }
            //     else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
            //     {
            //         setModalHeaderText("No Address Found");
            //         setModalBodyHTML("No address was found for the selected point");
            //         setModalFooterHTML(
            //             <Button variant='secondary' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} onClick={()=>{setShowDynamicModal(false);}}>
            //                 OK
            //             </Button>
            //         );
            //         setShowDynamicModal(true);
            //     }    
            //     enableDisableMap();
            // }
            // else
            // {
            //     if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
            //     {
            //         let DOAddr = OSRMResponse.data.results[0].formatted_address;
            //         let DOParsedData = ParseGeoCodedData(OSRMResponse.data.results[0], "", 0);
            //         props.mapPointSelection([{latlng:info, address:DOAddr, type:"DO", addressParsedObject:DOParsedData}]);
            //     }
            //     else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
            //     {
            //         setModalHeaderText("No Address Found");
            //         setModalBodyHTML("No address was found for the selected point");
            //         setModalFooterHTML(
            //             <Button variant='secondary' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} onClick={()=>{setShowDynamicModal(false);}}>
            //                 OK
            //             </Button>
            //         );
            //         setShowDynamicModal(true);
            //     }    
            //     enableDisableMap();
                
            // }
        }
        catch(err){console.log(err);}
    };


    const getMapZones = (map, maps, zone = "All Zones") => {
        try{
            let zoneDict = {};
            let zoneColorsDict = {};
            let tempAffTypeCheck = false; //Makes microtransit the only affiliate to not filter zones from map
            let selectedAff = parseInt(props.options.mapOptions.aff);
            let oms = new OverlappingMarkerSpiderfier(map, {
                markersWontMove: true,
                markersWontHide: true,
                spiderfiedShadowColor: false,
                nudgeStackedMarkers: false,
            });
            if(affChangedRef.current !== "")
            {
                selectedAff = affChangedRef.current;
                tempAffTypeCheck = AffiliateData.some(item => parseInt(item.AffiliateID) === parseInt(selectedAff) && parseInt(item.iTransType) === 2);
            }
            // zoneVSMarkers = [];
            // vsInfowindows = [];

            for(let s = 0 ; s < props.zones.length; s++)
            {
                if(parseInt(props.zones[s].iZVATSPID) === parseInt(selectedAff)) //props.selectedAffiliates
                {
                    let key = props.zones[s].vName;
                    if(key in zoneDict)
                    {
                        let zoneLocations = zoneDict[key];
                        let zoneColors = zoneColorsDict[key];
                        zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                        let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                        zoneLocations.push(tempDict);
                        zoneDict[key] = zoneLocations;
                        zoneColorsDict[key] = zoneColors;
                    }
                    else
                    {
                        let zoneLocations = [];
                        let zoneColors = [];
                        let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                        zoneLocations.push(tempDict);
                        zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                        zoneDict[key] = zoneLocations;
                        zoneColorsDict[key] = zoneColors;
                    }
                }
    
            }
            let counter = 0;
            let arr = [];
            let overallZoneList = [];
            let zoneSelOptions = [];
            let zonesVirtualStops = [];
            for(let m in zoneDict)
            {
                if(!overallZoneList.includes(m))
                {
                    let dict = {};
                    dict.name = m.toUpperCase();
                    dict.id = m.toUpperCase();
                    zoneSelOptions.push(dict);
                    overallZoneList.push(m);
                }
            }

            SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{options: zoneSelOptions}});
            
            

            if(tempAffTypeCheck === true){ // If Affiliate type is 2 (MicroTransit) then show the VStops otherwise hide them
                for(let k = 0; k < VirtualStopsData.length; k++)
                {
                  if(parseInt(selectedAff) === parseInt(VirtualStopsData[k].iSATSPID) && VirtualStopsData[k]["vRCZoneName"])
                    {
                        if(zone === "All Zones" || (zone.length > 0 && zone.includes(VirtualStopsData[k]["vRCZoneName"].trim().toUpperCase())))
                        {
                            zonesVirtualStops.push(VirtualStopsData[k]);
                        }
                    }
                }
            }
           
            // console.log(zone, zonesVirtualStops, zoneDict);
            for(let i in zoneDict)
            {
                if(!arr.includes(i))
                {
                    arr.push(i);
                }
                if(tempAffTypeCheck)
                {
                    polygons.push(new maps.Polygon({
                        paths: zoneDict[i],
                        strokeColor: "black",
                        strokeOpacity: 0.3,
                        strokeWeight: 2,
                        fillColor: zoneColorsDict[i][0].vZoneColor,
                        fillOpacity: 0.25,
                        title: i
                    }));
                    polygons[counter].setMap(map);
                    counter+=1;
                }
                else
                {
                    if(zone.length === overallZoneList.length || zone === "All Zones")
                    {
                        polygons.push(new maps.Polygon({
                            paths: zoneDict[i],
                            strokeColor: "black",
                            strokeOpacity: 0.3,
                            strokeWeight: 2,
                            fillColor: zoneColorsDict[i][0].vZoneColor,
                            fillOpacity: 0.25,
                            title: i
                        }));
                        polygons[counter].setMap(map);
                        counter+=1;
                    }
                    else if(zone.includes(i.toUpperCase()))
                    {
                        polygons.push(new maps.Polygon({
                            paths: zoneDict[i],
                            strokeColor: "black",
                            strokeOpacity: 0.3,
                            strokeWeight: 2,
                            fillColor: zoneColorsDict[i][0].vZoneColor,
                            fillOpacity: 0.25,
                            title: i
                        }));
                        polygons[counter].setMap(map);
                        counter+=1;
                    }
                    else if(zone.length === 0)
                    {
                        polygons = [];
                    }
                }  
            }
            
            polygons.forEach((polygon)=>{
                maps.event.addListener(polygon, "rightclick", (event) => {
                    let tempAffTypeCheck = AffiliateData.some(item => parseInt(item.AffiliateID) === parseInt(affChangedRef.current) && parseInt(item.iTransType) !== 2);
                    let lat = event.latLng.lat();
                    let lng = event.latLng.lng();
                    let combinedLatLng = String(lat)+","+String(lng);
                    setModalHeaderText("Address Selection From Map");
                    setModalBodyHTML(<p>{"Which address field would you like to set this for?"}</p>);
                    setModalFooterHTML(
                        <>
                            <div style={{justifyContent:'flex-end', display:"inline-flex", width:"100%"}}>
                                <Button variant='success' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} 
                                    onClick={async ()=>{ await handleMapPointSelection("PU", combinedLatLng)}}
                                >
                                    Pickup
                                </Button>
                                <Button variant='danger' className="border-0 rounded" style={{borderRadius:"0px"}}
                                 onClick={async ()=>{ await handleMapPointSelection("DO", combinedLatLng)}}
                                >
                                    Drop-off
                                </Button>
                                {false ? 
                                <Button variant='secondary' className="border-0 rounded ms-2" style={{borderRadius:"0px"}}
                                 onClick={async ()=>{ await handleMapPointSelection("Stop", combinedLatLng)}} disabled
                                >
                                    Stop
                                </Button>: ""}
                            </div>
                        </>
                    );
                    setShowDynamicModal(true);
                });
            });
            setPolygons(polygons);
            zoneList.current = arr;
            if(zonesVirtualStops && zonesVirtualStops.length > 0)
            {
                // console.log("came to first option with zones", zonesVirtualStops);
                for(let i = 0; i < zoneVSMarkers.length; i++) {
                    zoneVSMarkers[i].setMap(null);
                }
                for(let i = 0; i < vsInfowindows.length; i++) {
                    vsInfowindows[i].setMap(null);
                }
                zoneVSMarkers = [];
                vsInfowindows = [];
                // console.log(zonesVirtualStops);
                let updatedListofVS = [];
                let filteredSet = new Set();
                zonesVirtualStops.forEach((item)=>{
                    if(!filteredSet.has(item.ID))
                    {
                        updatedListofVS.push(item);
                        filteredSet.add(item.ID);
                    }
                    else
                    {
                        //update VS array to have a different rczZoneName
                        const existingItemIndex = updatedListofVS.findIndex(vs => vs.ID === item.ID);
                        updatedListofVS[existingItemIndex] = [updatedListofVS[existingItemIndex], item];
                    }
                });
                // console.log(updatedListofVS, Array.isArray(updatedListofVS[13]));
                updatedListofVS.forEach((virtualStop) => {
                    if(zone === "All Zones")
                    {
                        // console.log("all zones", zone);
                        if(Array.isArray(virtualStop))
                        {
                            zoneVSMarkers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(virtualStop[0].vLatitude),
                                    lng: parseFloat(virtualStop[0].vLongitude),
                                },
                                optimized: true, 
                                icon: {
                                    path: maps.SymbolPath.CIRCLE,
                                    fillColor: virtualStop[0].vColor,
                                    fillOpacity: 0.6,
                                    strokeColor: 'black',
                                    strokeOpacity: 0.9,
                                    strokeWeight: 1,
                                    scale: 4
                                },
                                data:virtualStop[0].ID,
                                map,
                            }));
                            vsInfowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(virtualStop[0], 'VS', virtualStop[0].vRCZoneName+","+virtualStop[1].vRCZoneName),
                            }));
                        }
                        else
                        {
                            zoneVSMarkers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(virtualStop.vLatitude),
                                    lng: parseFloat(virtualStop.vLongitude),
                                },
                                optimized: true, 
                                icon: {
                                    path: maps.SymbolPath.CIRCLE,
                                    fillColor: virtualStop.vColor,
                                    fillOpacity: 0.6,
                                    strokeColor: 'black',
                                    strokeOpacity: 0.9,
                                    strokeWeight: 1,
                                    scale: 4
                                },
                                data:virtualStop.ID,
                                map,
                            }));
                            vsInfowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(virtualStop, 'VS'),
                            }));
                        }
                        
                    }
                    else if(zone.length > 0)
                    {
                        // console.log("some zones", virtualStop.vRCZoneName.toLowerCase(), virtualStop);
                        // console.log(zoneVSMarkers, virtualStop.ID);
                        if(Array.isArray(virtualStop))
                        {
                            if(zone.includes(virtualStop[0].vRCZoneName.toUpperCase()) && zone.includes(virtualStop[1].vRCZoneName.toUpperCase()))
                            {
                                zoneVSMarkers.push(new maps.Marker({
                                    position: {
                                        lat: parseFloat(virtualStop[0].vLatitude),
                                        lng: parseFloat(virtualStop[0].vLongitude),
                                    },
                                    optimized: true, 
                                    icon: {
                                        path: maps.SymbolPath.CIRCLE,
                                        fillColor: virtualStop[0].vColor,
                                        fillOpacity: 0.6,
                                        strokeColor: 'black',
                                        strokeOpacity: 0.9,
                                        strokeWeight: 1,
                                        scale: 4
                                    },
                                    data:virtualStop[0].ID,
                                    map,
                                }));
                                vsInfowindows.push(new maps.InfoWindow({
                                    content: getInfoWindowString(virtualStop[0], 'VS', virtualStop[0].vRCZoneName+","+virtualStop[1].vRCZoneName),
                                }));
                            }
                            else if(zone.includes(virtualStop[0].vRCZoneName.toUpperCase()))
                            {
                                zoneVSMarkers.push(new maps.Marker({
                                    position: {
                                        lat: parseFloat(virtualStop[0].vLatitude),
                                        lng: parseFloat(virtualStop[0].vLongitude),
                                    },
                                    optimized: true, 
                                    icon: {
                                        path: maps.SymbolPath.CIRCLE,
                                        fillColor: virtualStop[0].vColor,
                                        fillOpacity: 0.6,
                                        strokeColor: 'black',
                                        strokeOpacity: 0.9,
                                        strokeWeight: 1,
                                        scale: 4
                                    },
                                    data:virtualStop[0].ID,
                                    map,
                                }));
                                vsInfowindows.push(new maps.InfoWindow({
                                    content: getInfoWindowString(virtualStop[0], 'VS', virtualStop[0].vRCZoneName+","+virtualStop[1].vRCZoneName),
                                }));
                            }
                            else if(zone.includes(virtualStop[1].vRCZoneName.toUpperCase()))
                            {
                                zoneVSMarkers.push(new maps.Marker({
                                    position: {
                                        lat: parseFloat(virtualStop[1].vLatitude),
                                        lng: parseFloat(virtualStop[1].vLongitude),
                                    },
                                    optimized: true, 
                                    icon: {
                                        path: maps.SymbolPath.CIRCLE,
                                        fillColor: virtualStop[0].vColor,
                                        fillOpacity: 0.6,
                                        strokeColor: 'black',
                                        strokeOpacity: 0.9,
                                        strokeWeight: 1,
                                        scale: 4
                                    },
                                    data:virtualStop[1].ID,
                                    map,
                                }));
                                vsInfowindows.push(new maps.InfoWindow({
                                    content: getInfoWindowString(virtualStop[1], 'VS', virtualStop[0].vRCZoneName+","+virtualStop[1].vRCZoneName),
                                }));
                            }
                        }
                        else if(zone.includes(virtualStop.vRCZoneName.toUpperCase()))
                        {
                            zoneVSMarkers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(virtualStop.vLatitude),
                                    lng: parseFloat(virtualStop.vLongitude),
                                },
                                optimized: true,
                                icon: {
                                    path: maps.SymbolPath.CIRCLE,
                                    fillColor: virtualStop.vColor,
                                    fillOpacity: 0.6,
                                    strokeColor: 'black',
                                    strokeOpacity: 0.9,
                                    strokeWeight: 1,
                                    scale: 4
                                },
                                data:virtualStop.ID,
                                map,
                            }));
                            vsInfowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(virtualStop, 'VS'),
                            }));
                        }
                    }
                    else
                    {
                        // console.log("no zones", zone);
                        zoneVSMarkers = [];
                        vsInfowindows = [];
                    }
                });
                
                if(zoneVSMarkers.length > 0)
                {
                    zoneVSMarkers.forEach((virtualStopMarker, i) => {
                        oms.addMarker(virtualStopMarker);
                        virtualStopMarker.addListener('mouseover', () => {
                            vsInfowindows[i].open(map, virtualStopMarker);
                        });
                        virtualStopMarker.addListener("mouseout", () => {
                            vsInfowindows[i].close();
                        });
                        virtualStopMarker.addListener('click', ()=>{
                            try{
                                let mainInfo = [];
                                for(let j = 0; j < zonesVirtualStops.length; j++)
                                {
                                    if(zonesVirtualStops[j].ID === virtualStopMarker.data)
                                    {
                                        mainInfo.push(zonesVirtualStops[j]);
                                    }
                                }
                                setModalHeaderText("Virtual Stop Selection Options");
                                setModalBodyHTML(<p>{"Please select a target field for this selection: ("}<b>{mainInfo[0].Location}</b>{")"}</p>);
                                setModalFooterHTML(
                                    <>
                                        <div style={{justifyContent:'flex-end', display:"inline-flex", width:"100%"}}>
                                            <Button variant='success' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} onClick={()=>{handleVSSelection("PU", mainInfo)}}>
                                                Pickup
                                            </Button>
                                            <Button variant='danger' className="border-0 rounded" style={{borderRadius:"0px"}} onClick={()=>{handleVSSelection("DO", mainInfo)}}>
                                                Drop-off
                                            </Button>
                                        </div>
                                        {/* <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                                            None
                                        </Button> */}
                                    </>
                                );
                                setShowDynamicModal(true);
                            }
                            catch(err){console.log(err);}
                        });
                    });
                    setZoneVSMarkers(zoneVSMarkers);
                    setVsInfowindows(vsInfowindows);
                }
                else
                {
                    zoneVSMarkers = [];
                    vsInfowindows = [];
                }
            }
            else
            {
                // console.log("no zones selected", zoneVSMarkers, vsInfowindows, markers);
                for(let i = 0; i < zoneVSMarkers.length; i++) {
                    zoneVSMarkers[i].setMap(null);
                }
                for(let i = 0; i < vsInfowindows.length; i++) {
                    vsInfowindows[i].setMap(null);
                }
                
                setZoneVSMarkers([]);
                setVsInfowindows([]);
            }
            // console.log(zoneVSMarkers.length);
        }
        catch(err){console.log(err);}
       
        // console.log(zoneList.current, zoneSelection.current);
    };

    const handleVSSelection = (type, data)=>{
        try{
            props.setIsSchTimeFieldDisabled(true);
            props.setIsVSSelectionDisabled(true);
            enableDisableMap(false);
            setShowDynamicModal(false);
            props.vsSelection([{type:type, data:data[0]}]);
            enableDisableMap();
        }
        catch(err){console.log(err);}
    };

    const getNearbyVehicles = () => {
        try{
            
            if(state.places && state.places.length > 0)
            {
                let vehData = [];
                let vehImage = [];
                for(let y = 0 ; y < state.places.length; y++)
                {
                    if(state.places[y].Type === "Vehicle")
                    {
                        vehData.push(state.places[y]);
                    }
                }
                if (vehData.length === 1 && vehData.length !== 0 ) {
                    let veh_data = vehData[0];
                    if (veh_data.VehInfo?.split(" ")[1].toUpperCase() === "VAN" || veh_data.VehInfo?.split(" ")[1].toUpperCase() === "WAGON") {
                        if (veh_data.State.toUpperCase() === "DISCONNECTED") {
                            vehImage.push(CabDisconnected);
                        } else if (veh_data.State.toUpperCase() === "OCCUPIED" || veh_data.State.toUpperCase() === "PICKEDUP") {
                            vehImage.push(VanOccupied);
                        } else if (veh_data.State.toUpperCase() === "OFFLINE") {
                            vehImage.push(CabOffline);
                        } else if (veh_data.State.toUpperCase() === "ACCEPTED" || veh_data.State.toUpperCase() === "ONLINE" 
                            || veh_data.State.toUpperCase() === "IRTPU" || veh_data.State.toUpperCase() === "ATLOCATION") {
                            vehImage.push(VanOnline);
                        }
                    }
                    else {
                        if (veh_data.State.toUpperCase() === "DISCONNECTED") {
                            vehImage.push(CabDisconnected);
                        } else if (veh_data.State.toUpperCase() === "OCCUPIED" || veh_data.State.toUpperCase() === "PICKEDUP") {
                            vehImage.push(SedanOccupied);
                        } else if (veh_data.State.toUpperCase() === "OFFLINE") {
                            vehImage.push(CabOffline);
                        } else if (veh_data.State.toUpperCase() === "ACCEPTED" || veh_data.State.toUpperCase() === "ONLINE" 
                            || veh_data.State.toUpperCase() === "IRTPU" || veh_data.State.toUpperCase() === "ATLOCATION") {
                            vehImage.push(SedanOnline);
                        }
                    }
                }
                else {

                    for (let vehicle in vehData) {
                        if(vehData[vehicle].VehInfo?.split(" ")[1].toUpperCase() === "VAN" || vehData[vehicle].VehInfo?.split(" ")[1].toUpperCase() === "WAGON")
                        {
                            if(vehData[vehicle].State.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "OCCUPIED" || vehData[vehicle].State.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(VanOccupied);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "ONLINE" || vehData[vehicle].State.toUpperCase() === "IRTPU" || vehData[vehicle].State.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(VanOnline);
                            }
                        }
                        else if(vehData[vehicle].VehInfo?.split(" ")[1].toUpperCase() === "VPG" || vehData[vehicle].VehInfo?.split(" ")[1].toUpperCase() === "LIFT")
                        {
                            if(vehData[vehicle].State.toUpperCase() === "OCCUPIED" || vehData[vehicle].State.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(LiftOccupied);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "ONLINE" || vehData[vehicle].State.toUpperCase() === "IRTPU" || vehData[vehicle].State.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(LiftOnline);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                        }
                        else
                        {
                            if(vehData[vehicle].State.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "OCCUPIED" || vehData[vehicle].State.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(SedanOccupied);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                            else if(vehData[vehicle].State.toUpperCase() === "ONLINE" || vehData[vehicle].State.toUpperCase() === "IRTPU" || vehData[vehicle].State.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(SedanOnline);
                            }
                        }
                    }
                }
                vehImageArr = vehImage;
            }
            
        }
        catch(err){};
       
    };

    const getInfoWindowString = (place, type, customZone = "") => {
        try{
            let common_info = "";
            if (type === 'PU') {
                common_info += `
                  <div>
                    <div class="text-start">
                      <b class="fw-bold">Rider:</b> ${place.name} <br>
                      <b class="fw-bold">Address:</b> ${place.address} <br>
                    </div>
                  </div>`;
            }
            else  if (type === 'DO') {
                common_info += `
                    <div>
                    <div class="text-start">
                        <b class="fw-bold">Rider:</b> ${place.name} <br>
                        <b class="fw-bold">Address:</b> ${place.address} <br>
                    </div>
                    </div>`;

            } else if (type === 'Alert') {
                common_info += `
                  <div>
                    <div class="text-start">
                      <b class="fw-bold">Alert Type:</b> ${place.name} <br>
                      <b class="fw-bold">Address:</b> ${place.address} <br>
                      <b class="fw-bold">Description:</b> ${place.description} <br>
                    </div>
                  </div>`;
            }
            else if (type === 'Stop') {
                common_info += `
                  <div>
                    <div class="text-start">
                      <b class="fw-bold">Rider:</b> ${place.name} <br>
                      <b class="fw-bold">Address:</b> ${place.address} <br>
                      <b class="fw-bold">Type:</b> ${place.stopType === "none" ? "Wait Stop" : (place.stopType.charAt(0).toUpperCase() + place.stopType.slice(1).toLowerCase() + " Stop")} <br>
                      ${place.description.trim() !== "" ? `<b class="fw-bold">Description:</b> ${place.description} <br>` : ''}
                    </div>
                  </div>`;
            }
            else if(type === 'Vehicle'){
                common_info += `
                  <div>
                    <div class="text-start">
                        <b class="fw-bold float-left">Vehicle #:</b>${place.VehNo} <b class="fw-bold float-right" >Driver #:<b class="fw-light">${place.DriverNo}</b></b> <br>
                        <b class="fw-bold">State:</b> ${(place.State === undefined || place.State === null?"N/A":place.State)} <br>
                        <b class="fw-bold">VehicleInfo:</b> ${place.VehInfo?.split(" ")[0] + "("+place.VehInfo?.split(" ")[1]+")"} <br>
                        <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                    </div>
                  </div>`;
            }
            else if(type === 'Depot'){
                common_info += `
                    <div>
                    <div class="text-start">
                        <b class="fw-bold">Depot Name:</b> ${place.Type} <br>
                        <b class="fw-bold">Address:</b> ${place.address} <br>
                    </div>
                    </div>`;
            }
            else if(type === 'VS'){
                if(customZone === "")
                {
                    common_info += `
                    <div>
                    <div class="text-start">
                        <b class="fw-bold">Virtual Stop:</b> ${place.Location} <br>
                        <b class="fw-bold">Adress:</b> ${place.Street} <br>
                        <b class="fw-bold">Zone:</b> ${place.vRCZoneName} <br>
                    </div>
                    </div>`;
                }
                else
                {
                    common_info += `
                    <div>
                    <div class="text-start">
                        <b class="fw-bold">Virtual Stop:</b> ${place.Location} <br>
                        <b class="fw-bold">Adress:</b> ${place.Street} <br>
                        <b class="fw-bold">Zones:</b> ${customZone} <br>
                    </div>
                    </div>`;
                }
            }

            return common_info;
        }
        catch(err){console.log(err);}
       
    };

    const getMapBounds = (map, maps, places)=>{
        try{
            const bounds = new maps.LatLngBounds();
            if(places[0].lat !== null)
            {
                places.forEach((place) => {
                    if(place.lat !== "")
                    {
                        bounds.extend(new maps.LatLng(
                            parseFloat(place.lat),
                            parseFloat(place.lng),
                        ));
                    }
                });
                return bounds;
            }
        }
        catch(err){console.log(err);}
    };

    const ZoneSelectionCallback = (selectedVals)=> {
        try{
            setSelectedZone(selectedVals);
            if(typeof GlobalMapsObjects.map !== 'undefined')
            {
                // console.log(selectedVals);
                for(let i = 0; i < polygons.length; i++) {
                    polygons[i].setMap(null);
                }
                polygons = [];
                getMapZones(GlobalMapsObjects.map, GlobalMapsObjects.maps, selectedVals);
            }
            SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{selectedValues: selectedVals}});
            
        }
        catch(err){console.log(err);}
    };

    const handleRecenterClick = (map, maps)=>{
        try{
            if(affChangedRef.current !== "")
            {
                startCenterLat = ASCSSettingData[affChangedRef.current] ? 
                    (JSON.parse(ASCSSettingData[affChangedRef.current]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value
                    : 39.16552683625823;
                startCenterLng = ASCSSettingData[affChangedRef.current] ? 
                    (JSON.parse(ASCSSettingData[affChangedRef.current]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value
                    : -77.16834351718929;
            }
            
            map.setCenter({lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)});
            map.setZoom(state.zoom);
        }
        catch(err){console.log(err);}
    };

    const handlePOISearch = async(e)=>{
        try{
            let userInput = e.target.value.toLowerCase();
            setInputPOI(e.target.value);
            if(userInput.trim().length >= 4)
            {
                let myHeaders = new Headers();
                myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
                myHeaders.append('Content-Type', 'application/json');
                let mapBounds = (JSON.parse(ASCSSettingData[affChangedRef.current]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
                let addressAPI = ITCMapURL + encodeURIComponent(userInput) + "&bounds="+mapBounds+ "&AppType=CallTaker";
                let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
                console.log(OSRMResponse);
            }
        }
        catch(err){console.log(err);}
    };

    const handleApiLoaded = async(map, maps, places) => {
        try{
            // RemoveAllMapObjects();  
            IsCallInProgressForHandleApiLoaded.current = true;
            if(props.options.mapOptions.aff && !mapZoneCreated.current)
            {
                polygons = [];
                getMapZones(map, maps);
                mapZoneCreated.current = true;
                if(zoneList.current.length > 0)
                {
                    // map.controls[maps.ControlPosition.RIGHT_TOP].push(createZoneMapMultiSelect(map, maps));
                    if(zoneList.current.length > 0)
                    {                        
                        const controlDiv = document.createElement('div'); 
                        const root = createRoot(controlDiv);
                        root.render(
                            <MultiSelectDropdown options={ZonesFilterMultiSelect} SelectionChangeCallback={ZoneSelectionCallback} FireSelectEventOnEveryItemChange={true}/>    
                        );
                        map.controls[maps.ControlPosition.RIGHT_TOP].push(controlDiv);
                    }
                   
                }
            }
            else
            {
                polygons = [];
            }
            if(!recenterBtnCreatedFlag && props.options.mapOptions.aff)
            {
                const controlDiv = document.createElement('div'); 
                const root = createRoot(controlDiv);
                root.render(
                    <Button variant='light' tabIndex={-1} type='button' className='m-1 shadow' title={"Recenter Map"} onClick={(e)=>{handleRecenterClick(map,maps);}}>
                        <Icon icon="bx:collapse" style={{width:"15px", height:"15px"}}/>
                    </Button>    
                );
                map.controls[maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
                setRecenterBtnCreatedFlag(true);
            }
            // if(!searchPOICreatedFlag && props.options.mapOptions.aff)
            // {
            //     const controlDiv = document.createElement('div'); 
            //     const root = createRoot(controlDiv);
            //     root.render(
            //         <input type='search' className='shadow-sm border-0 px-1 m-1' style={{minHeight:"30px"}} placeholder='Search POI' onChange={handlePOISearch}/>    
            //     );
            //     map.controls[maps.ControlPosition.TOP_LEFT].push(controlDiv);
            //     setSearchPOICreatedFlag(true);
            // }
            if(props.options.mapOptions.aff && !rightClickListenerRef.current)
            {
                rightClickListenerRef.current = true;
                maps.event.addListener(map, "rightclick", function(event){
                    let tempAffTypeCheck = AffiliateData.some(item => parseInt(item.AffiliateID) === parseInt(affChangedRef.current) && parseInt(item.iTransType) !== 2);
                    let lat = event.latLng.lat();
                    let lng = event.latLng.lng();
                    let combinedLatLng = String(lat)+","+String(lng);
                    setModalHeaderText("Address Selection From Map");
                    setModalBodyHTML(<p>{"Which address field would you like to set this for?"}</p>);
                    setModalFooterHTML(
                        <>
                            <div style={{justifyContent:'flex-end', display:"inline-flex", width:"100%"}}>
                                <Button variant='success' className="border-0 rounded" style={{marginRight:"10px", borderRadius:"0px"}} 
                                    onClick={async ()=>{ await handleMapPointSelection("PU", combinedLatLng)}}
                                >
                                    Pickup
                                </Button>
                                <Button variant='danger' className="border-0 rounded" style={{borderRadius:"0px"}} 
                                    onClick={async ()=>{await handleMapPointSelection("DO", combinedLatLng)}}
                                >
                                    Drop-off
                                </Button>
                                {false ? 
                                    <Button variant='danger' className="border-0 rounded ms-2" style={{borderRadius:"0px"}}
                                        onClick={async ()=>{ await handleMapPointSelection("Stop", combinedLatLng)}} disabled
                                    >
                                        Stop
                                    </Button>
                                : ""}
                            </div>
                        </>
                    );
                    setShowDynamicModal(true);
                });
            }

            if(places && places.length > 0)
            {
                // console.log(places);
                const bounds = getMapBounds(map, maps, places);
                let oms = new OverlappingMarkerSpiderfier(map, {
                    markersWontMove: true,
                    markersWontHide: true,
                    spiderfiedShadowColor: false,
                    nudgeStackedMarkers: false,
                });
                markers = [];
                setMarkers([]);
                infowindows = [];
                PolyPaths = [];
                getNearbyVehicles();
                let counter = 0;
                let stopOrder = 0;
                let newPathArray = [];
                places.forEach((place) => {
                   if(place.lat !== "")
                   {
                        if(place.Type === "PU")
                        {
                            stopOrder+=1;
                            markers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(place.lat),
                                    lng: parseFloat(place.lng),
                                },
                                label: {text:(state.mapPolylines && state.mapPolylines.multiple?("P"+stopOrder):"P"), className:"fw-bold marker_label_css"},
                                icon: place.TripStatus === "NewTrip" ? NewTripPUIcon : PUIcon,
                                map,
                            }));
                            if(state.mapPolylines && state.mapPolylines.multiple)
                            {
                                newPathArray.push({trip:"P", latLng: new maps.LatLng(parseFloat(place.lat),parseFloat(place.lng)), time: place.SchTime});
                            }
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'PU'),
                            }));
                        }
                        else if(place.Type === "DO")
                        {

                            stopOrder+=1;

                            const markerOptions = {
                                position: {
                                    lat: parseFloat(place.lat),
                                    lng: parseFloat(place.lng),
                                },
                                label: {
                                    text: (state.mapPolylines && state.mapPolylines.multiple ? "D" + stopOrder : "D"),
                                    className: "fw-bold marker_label_css_DO"
                                },
                                map,
                            };
                            // Set the icon conditionally
                            if (place.TripStatus === "NewTrip") {
                                markerOptions.icon = NewTripDOIcon;
                            }

                            markers.push(new maps.Marker(markerOptions));
                            if(state.mapPolylines && state.mapPolylines.multiple)
                            {
                                newPathArray.push({trip:"D", latLng: new maps.LatLng(parseFloat(place.lat),parseFloat(place.lng)), time: place.SchTime});
                            }
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'DO'),
                            }));
                            
                        }
                        else if(place.Type === "Alert")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(place.lat),
                                    lng: parseFloat(place.lng),
                                },
                                icon: AlertLocationMarkerIcon,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Alert'),
                            }));
                        }
                        else if(place.Type === "StartDept" || place.Type === "StartDepot")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.lat),
                                lng: parseFloat(place.lng),
                                },
                                // icon:{text:"S", className:"fw-bold mt-1 startDepotStyle", style:"text-color:green", name:"DriverDepot"},
                                icon:SDepot,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Depot'),
                            }));
                        }
                        else if(place.Type === "EndDept" || place.Type === "EndDepot")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.lat),
                                lng: parseFloat(place.lng),
                                },
                                // label:{text:"E", className:"fw-bold mt-1 endDepotStyle", name:"DriverDepot"},
                                icon:EDepot,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Depot'),
                            }));
                        }
                        else if(place.Type === "Walk")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.lat),
                                lng: parseFloat(place.lng),
                                },
                                // label:{text:"E", className:"fw-bold mt-1 endDepotStyle", name:"DriverDepot"},
                                icon:WalkIcon,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'PU'),
                            }));
                        }
                        else if(place.Type === "Stop")
                        {
                            let iconImage = place.stopType === "load" ? "https://maps.gstatic.com/mapfiles/ms2/micons/green.png": 
                                (place.stopType === "unload" ? "https://maps.gstatic.com/mapfiles/ms2/micons/red.png" : "https://maps.gstatic.com/mapfiles/ms2/micons/blue.png");
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.lat),
                                lng: parseFloat(place.lng),
                                },
                                // label:{text:"E", className:"fw-bold mt-1 endDepotStyle", name:"DriverDepot"},
                                icon:iconImage,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Stop'),
                            }));
                        }
                        else if(place.Type === "Drop")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.lat),
                                lng: parseFloat(place.lng),
                                },
                                // label:{text:"E", className:"fw-bold mt-1 endDepotStyle", name:"DriverDepot"},
                                icon:DropMicrotransitIcon,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'DO'),
                            }));
                        }
                        else if(place.Type === "Vehicle")
                        {
                            // console.log(vehImageArr[counter]);
                            markers.push(new maps.Marker({
                                position: {
                                    lat: parseFloat(place.lat),
                                    lng: parseFloat(place.lng),
                                },
                                icon: vehImageArr[counter],
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Vehicle'),
                            }));
                            counter+=1;
                        }
                   }

                });
                if(state.mapPolylines)
                {
                    if(state.mapPolylines.single) //Make polyline follow the road
                    {
                        let tempAffTypeCheck = AffiliateData.some(item => parseInt(item.AffiliateID) === parseInt(affChangedRef.current) && parseInt(item.iTransType) !== 2);
                        if(places.length === 2)
                        {
                            let ndirectionsapi = ITCMapDirections + "?origin=" + String(places[0].lat)+","+String(places[0].lng) + 
                                "&destination=" + String(places[1].lat)+","+String(places[1].lng) + "&AppType=Web_Reservation";
                            await getDynamicPolylines(ndirectionsapi, [], 2);
                            // let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(places[0].lat),parseFloat(places[0].lng))
                            //     ,latlngDO:new maps.LatLng(parseFloat(places[1].lat),parseFloat(places[1].lng))}; 
                            // let polyPath = new maps.Polyline({
                            //     path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                            //     geodesic: true,
                            //     strokeColor: "brown",
                            //     strokeOpacity: 0.9,
                            //     strokeWeight: 2,
                            // });
                            // polyPath.setMap(map);
                            // PolyPaths.push(polyPath);
                            // setPolyPaths(PolyPaths);
                        }
                        else if(places.length === 4 && !tempAffTypeCheck)
                        {
                            if(places[0].lat !== "")
                            {
                                let walktoPUndirectionsapi = ITCMapDirections + "?origin=" + String(places[0].lat)+","+String(places[0].lng) + 
                                    "&destination=" + String(places[1].lat)+","+String(places[1].lng) + "&AppType=Web_Reservation";
                                    
                                // await getDynamicPolylines(walktoPUndirectionsapi, ["black"], 4);
                                if(polylinePointsMicro.current.pick !== 0)
                                    decrpytpoly(polylinePointsMicro.current.pick, ["black"], 4);
                                
                            }
                            let PUtoDOndirectionsapi = ITCMapDirections + "?origin=" + String(places[1].lat)+","+String(places[1].lng) + 
                                "&destination=" + String(places[2].lat)+","+String(places[2].lng) + "&AppType=Web_Reservation";

                            await getDynamicPolylines(PUtoDOndirectionsapi, ["brown"], 4);

                            if(places[3].lat !== "")
                            {
                                let DOtoFinishndirectionsapi = ITCMapDirections + "?origin=" + String(places[2].lat)+","+String(places[2].lng) + 
                                    "&destination=" + String(places[3].lat)+","+String(places[3].lng) + "&AppType=Web_Reservation";

                                // await getDynamicPolylines(DOtoFinishndirectionsapi, ["black"], 4);
                                if(polylinePointsMicro.current.drop !== 0)
                                    decrpytpoly(polylinePointsMicro.current.drop, ["black"], 4);
                                
                            }

                            polylinePointsMicro.current = {pick: 0, drop: 0};
                            // let lineDictAdditional = {latlngWalk: new maps.LatLng(parseFloat(places[0].lat),parseFloat(places[0].lng))
                            //     ,latlngPU:new maps.LatLng(parseFloat(places[1].lat),parseFloat(places[1].lng)),
                            //     latlngDO:new maps.LatLng(parseFloat(places[2].lat),parseFloat(places[2].lng)),
                            //     latlngDrop:new maps.LatLng(parseFloat(places[3].lat),parseFloat(places[3].lng))
                            // };
                            // let lineSymbol = {
                            //     strokeColor: "black",
                            //     path: 'M 0,-1 0,1',
                            //     strokeOpacity: 0.8,
                            //     scale: 3
                            // }; 
                            // if(places[0].lat !== "")
                            // {
                                
                            //     let polyPath1 = new maps.Polyline({
                            //         path: [lineDictAdditional.latlngWalk, lineDictAdditional.latlngPU],
                            //         geodesic: true,
                            //         strokeOpacity: 0,
                            //         icons: [{
                            //             icon: lineSymbol,
                            //             offset: '10px',
                            //             repeat: '15px'
                            //         }],
                            //         strokeWeight: 2,
                            //     });
                            //     polyPath1.setMap(map);
                            //     PolyPaths.push(polyPath1);
                            // }
                            
                            // let polyPath2 = new maps.Polyline({
                            //     path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                            //     geodesic: true,
                            //     strokeColor: "brown",
                            //     strokeOpacity: 0.9,
                            //     strokeWeight: 2,
                            // });
                            // if(places[3].lat !== "")
                            // {
                            //     let polyPath3 = new maps.Polyline({
                            //         path: [lineDictAdditional.latlngDO, lineDictAdditional.latlngDrop],
                            //         strokeOpacity: 0,
                            //         icons: [{
                            //             icon: lineSymbol,
                            //             offset: '10px',
                            //             repeat: '15px'
                            //         }],
                            //         strokeWeight: 2,
                            //     });
                            //     polyPath3.setMap(map);
                            //     PolyPaths.push(polyPath3);
                            // }
                            // polyPath2.setMap(map);
                            // PolyPaths.push(polyPath2);
                            // setPolyPaths(PolyPaths);
                            
                        }
                        else if(places.length > 2 && tempAffTypeCheck)
                        {
                            for(let i = 0; i < places.length; i++)
                            {
                                if(i !== (places.length - 1))
                                {
                                    let directionsapi = ITCMapDirections + "?origin=" + String(places[i].lat)+","+String(places[i].lng) + 
                                    "&destination=" + String(places[(i+1)].lat)+","+String(places[(i+1)].lng) + "&AppType=Web_Reservation";

                                    await getDynamicPolylines(directionsapi, ["brown"], places.length);
                                }
                            }
                        }
                    }
                    else if(state.mapPolylines.multiple)
                    {
                        //Multiple Polylines
                        getStraightPolylines(newPathArray, map, maps);
                    }
                    
                }
                if(bounds)
                {
                    if(markers.length === 1)
                    {
                        // let boundsSingleMarker = null;
                        places.forEach((place)=>{
                            if(place.lat !== "")
                            {
                                bounds.extend(new maps.LatLng(
                                    parseFloat(place.lat),
                                    parseFloat(place.lng),
                                ));
                            }
                        });

                        let extendedBounds = new maps.LatLngBounds(
                            new maps.LatLng(bounds.getSouthWest().lat() - 0.01, bounds.getSouthWest().lng() - 0.01),
                            new maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01)
                        );
                    
                        // Fit the extended bounds to the map viewport
                        map.fitBounds(extendedBounds);
                    }
                    else
                    {
                        map.fitBounds(bounds);
                    }
                }
                if(markers.length > 0)
                {
                    markers.forEach((marker, i) => {
                        oms.addMarker(marker);
                        marker.addListener('mouseover', () => {
                            infowindows[i].open(map, marker);
                        });
                        marker.addListener("mouseout", () => {
                            infowindows[i].close();
                        });
                    });
                    setMarkers(markers);
                    setinfowindows(infowindows);
                }
            }
            IsCallInProgressForHandleApiLoaded.current = false;
        }
        catch(err){console.log(err);}
    };

    const getStraightPolylines = (newPathArray, map, maps) => {
        try{
            let temp1DSequence = [];
            let line = null;
            
            for(var i = 0; i < newPathArray.length; i++)
            {
    
                if(newPathArray[i]["trip"] === "P")
                {
                    temp1DSequence.push(newPathArray[i]["trip"]);
                }
                if(i !== (newPathArray.length - 1))
                {
                    
                    if(newPathArray[i]["trip"] === "D")
                    {
                        temp1DSequence.shift();
                        if(temp1DSequence.length === 0)
                        {
                            let lineSymbol = {
                                strokeColor: "purple",
                                path: 'M 0,-1 0,1',
                                strokeOpacity: 0.8,
                                scale: 3
                            };
                            line = new maps.Polyline({
                                path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                                strokeOpacity: 0,
                                icons: [{
                                    icon: lineSymbol,
                                    offset: '10px',
                                    repeat: '15px'
                                }],
                                strokeWeight: 2
                            });
                            //var ndirectionsapi = directionsapi + "origin="+fullLatLngInfo[i]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i]["LocationInfo"].lng()+"&destination="+fullLatLngInfo[i+1]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i+1]["LocationInfo"].lng()+"&AppType=GPS";
                            // await getPolyLines(ndirectionsapi, lineSymbol, 2);
                        }
                        else
                        {
                            line = new maps.Polyline({
                                path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                                strokeColor: "black",
                                strokeOpacity: 0.9,
                                strokeWeight: 2
                            });
                            // await getPolyLines(ndirectionsapi, "", 2);
                        }
                    }
                    else
                    {
                        line = new maps.Polyline({
                            path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                            strokeColor: "black",
                            strokeOpacity: 0.9,
                            strokeWeight: 2
                        });
                        // await getPolyLines(ndirectionsapi, "", 2);
                    }
                    line.setMap(map);
                    PolyPaths.push(line);
                    setPolyPaths(PolyPaths);
                }
                
            }
        }
        catch(err){console.log(err);}
    };

    const getDynamicPolylines = async(ndirectionsapi, lineSymbol, count) => {
        try{
            let myHeaders = new Headers();
            myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
            myHeaders.append('Content-Type', 'application/json');
            let OSRMResponse = await APICom.fetchData("full", ndirectionsapi, "get2", myHeaders, {});
            if(OSRMResponse && OSRMResponse.error === "")
            {
                if(OSRMResponse.data.status.toUpperCase() === "OK")
                {
                    let encryptedPolylines = OSRMResponse.data.routes[0]["overview_polyline"]["points"];
                    decrpytpoly(encryptedPolylines, lineSymbol, count);
                }
            }
        }
        catch(err){console.log(err);}
    };

    const decrpytpoly = (encrptedpolylines, lineSymbol, count) => {
        try{
            let polyline = {};
  
            polyline.decode = function(str, precision) {
                let index = 0,
                    lat = 0,
                    lng = 0,
                    coordinates = [],
                    shift = 0,
                    result = 0,
                    byte = null,
                    latitude_change,
                    longitude_change,
                    factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
            
                // Coordinates have variable length when encoded, so just keep
                // track of whether we've hit the end of the string. In each
                // loop iteration, a single coordinate is decoded.
                while (index < str.length) {
            
                    // Reset shift, result, and byte
                    byte = null;
                    shift = 0;
                    result = 0;
            
                    do {
                        byte = str.charCodeAt(index++) - 63;
                        result |= (byte & 0x1f) << shift;
                        shift += 5;
                    } while (byte >= 0x20);
            
                    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
            
                    shift = result = 0;
            
                    do {
                        byte = str.charCodeAt(index++) - 63;
                        result |= (byte & 0x1f) << shift;
                        shift += 5;
                    } while (byte >= 0x20);
            
                    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
            
                    lat += latitude_change;
                    lng += longitude_change;
            
                    coordinates.push([lat / factor, lng / factor]);
                }
            
                return coordinates;
            };
            
            
            let decryptedpolylines = polyline.decode(encrptedpolylines);
            let polycoord = [];
            for(let i = 0; i < decryptedpolylines.length; i++){
                let latlong = {};
                latlong["lat"] = decryptedpolylines[i][0];
                latlong["lng"] = decryptedpolylines[i][1];
                polycoord.push(latlong);
            }
            plotDynamicPolyLines(polycoord, lineSymbol, count);
        }
        catch(err){console.log(err);}
    };

    const plotDynamicPolyLines = (Coordinates, lineSymbol, count) => {
        try{
            let polyPath = null;
            let tempAffTypeCheck = AffiliateData.some(item => parseInt(item.AffiliateID) === parseInt(affChangedRef.current) && parseInt(item.iTransType) !== 2);
            if(typeof GlobalMapsObjects.map !== 'undefined')
            {
                if(count === 2)
                {
                    //Grouped Lines (no purple)
                    polyPath = new GlobalMapsObjects.maps.Polyline({
                        // path: [new google.maps.LatLng(picklatlng), new google.maps.LatLng(droplatlng)],
                        path: Coordinates,
                        strokeColor: "brown",
                        geodesic: true,
                        strokeOpacity: 0.9,
                        strokeWeight: 2
                    });
                    polyPath.setMap(GlobalMapsObjects.map);
                    PolyPaths.push(polyPath);
                    setPolyPaths(PolyPaths);
                }
                else if(count === 4 && !tempAffTypeCheck)
                {
                    let lineSymbolPattern = {
                        strokeColor: "black",
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 0.8,
                        scale: 3
                    }; 
                    if(lineSymbol[0].toLowerCase() === "black")
                    {
                        polyPath = new GlobalMapsObjects.maps.Polyline({
                            path: Coordinates,
                            geodesic: true,
                            strokeOpacity: 0,
                            icons: [{
                                icon: lineSymbolPattern,
                                offset: '10px',
                                repeat: '15px'
                            }],
                            strokeWeight: 2,
                        });
                        polyPath.setMap(GlobalMapsObjects.map);
                        PolyPaths.push(polyPath);
                        setPolyPaths(PolyPaths);
                    }
                    else if(lineSymbol[0].toLowerCase() === "brown")
                    {
                        polyPath = new GlobalMapsObjects.maps.Polyline({
                            path: Coordinates,
                            geodesic: true,
                            strokeColor: "brown",
                            strokeOpacity: 0.9,
                            strokeWeight: 2,
                        });
                        polyPath.setMap(GlobalMapsObjects.map);
                        PolyPaths.push(polyPath);
                        setPolyPaths(PolyPaths);
                    }
                }
                else if(count > 2 && tempAffTypeCheck)
                {
                    
                    polyPath = new GlobalMapsObjects.maps.Polyline({
                        path: Coordinates,
                        geodesic: true,
                        strokeColor: "brown",
                        strokeOpacity: 0.9,
                        strokeWeight: 2,
                    });
                    polyPath.setMap(GlobalMapsObjects.map);
                    PolyPaths.push(polyPath);
                    setPolyPaths(PolyPaths);
                    
                }
                // else if(lineSymbol == "" && strokeWeight == 3)
                // {
                //     //Single Lines (no purple)
                //     polyPath = new GlobalMapsObjects.maps.Polyline({
                //         path: Coordinates,
                //         geodesic: true,
                //         strokeColor: "black",
                //         strokeOpacity: 0.6,
                //         strokeWeight: 3,
                //     });
                // }
                // else if(lineSymbol != "" && strokeWeight == 2)
                // {
                //     //Grouped Lines Idle Time (purple dashes)
                //     polyPath = new GlobalMapsObjects.maps.Polyline({
                //         // path: [new google.maps.LatLng(picklatlng), new google.maps.LatLng(droplatlng)],
                //         path: Coordinates,
                //         strokeOpacity: 0,
                //         icons: [{
                //             icon: lineSymbol,
                //             offset: '10px',
                //             repeat: '15px'
                //         }],
                //         strokeWeight: 2
                //     });
                // }
                
            }
        }
        catch(err){console.log(err);}
    };

    const ResetMapFromCallTaker = () => {
        try{
            resetMapFromCallTaker.current = true;
            // for(let i = 0; i < markers.length; i++) {
            //     markers[i].setMap(null);
            // }
            markers.forEach(marker => marker.setMap(null));
            markers = [];
            // for(let i = 0; i < PolyPaths.length; i++) {
            //     PolyPaths[i].setMap(null);
            // }
            PolyPaths.forEach(PolyPath => PolyPath.setMap(null));
            PolyPaths = [];
            // for(let i = 0; i < infowindows.length; i++) {
            //     infowindows[i].setMap(null);
            // }
            infowindows.forEach(infowindow => infowindow.setMap(null));
            infowindows = [];
        }
        catch(err){console.log(err);}
    }

    const RemoveAllMapObjects = () => {
        try{
            resetMapFromCallTaker.current = true;
            // for(let i = 0; i < zoneVSMarkers.length; i++) {
            //     zoneVSMarkers[i].setMap(null);
            // }
            zoneVSMarkers.forEach(zoneVSMarker => zoneVSMarker.setMap(null));
            zoneVSMarkers = [];
            // for(let i = 0; i < vsInfowindows.length; i++) {
            //     vsInfowindows[i].setMap(null);
            // }
            vsInfowindows.forEach(vsInfowindow => vsInfowindow.setMap(null));
            vsInfowindows = [];
            // for(let i = 0; i < polygons.length; i++) {
            //     polygons[i].setMap(null);
            // }
            polygons.forEach(polygon => polygon.setMap(null));
            polygons = [];
         
            // for(let i = 0; i < markers.length; i++) {
            //     markers[i].setMap(null);
            // }
            markers.forEach(marker => marker.setMap(null));
            markers = [];
            // for(let i = 0; i < PolyPaths.length; i++) {
            //     PolyPaths[i].setMap(null);
            // }
            PolyPaths.forEach(PolyPath => PolyPath.setMap(null));
            PolyPaths = [];
            // for(let i = 0; i < infowindows.length; i++) {
            //     infowindows[i].setMap(null);
            // }
            infowindows.forEach(infowindow => infowindow.setMap(null));
            infowindows = [];
        }
        catch(err){console.log(err);}
    }

    useEffect( () => {
        return() => {
            RemoveAllMapObjects();
        };
    }, []);
    return(
        <Col id={state.GridName + '_mapContainer'}  onContextMenu={(e)=>e.preventDefault()} style={{height:"100%",padding: 0 }}>
           <GoogleMapReact bootstrapURLKeys={{key:'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI'}} yesIWantToUseGoogleMapApiInternals 
               defaultCenter={state.center} defaultZoom={state.zoom} tilt={state.tilt} mapId={state.mapId} 
                options={{gestureHandling: state.options.gestureHandling, disableDefaultUI: true,
                   zoomControl: zoomOpt.zoomControl, fullscreenControl: state.mapDefaultBtns, streetViewControl:state.mapDefaultBtns, 
                   mapTypeControl:state.mapDefaultBtns, draggable: zoomOpt.draggable, scrollwheel: zoomOpt.scrollWheel, disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom}} 
               onGoogleApiLoaded={async ({ map, maps }) => { 
                   await handleApiLoaded(map, maps, state.places);
                   setGlobalMapsObjects({map:map, maps:maps});
                   map.setCenter({lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)});
               }
            }>   
                
           </GoogleMapReact>
           {showDynamicModal ? 
                <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
                    <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                        <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
                    <Modal.Footer className='p-0 px-2 py-1 justify-content-center'>
                        {modalFooterHTML}
                    </Modal.Footer>
                </Modal>
            : ""}
       </Col>
           
   );
};

export default MapControlSkeleton;